import { Button, Stack } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function TaskEditorToolbar({ onDone }) {
    return (
        <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
            <Button
                size="small"
                startIcon={<Iconify icon="eva:eye-outline" />}
                onClick={onDone}
                data-cy="task-editor-done-editing"
            >
                Done editing
            </Button>
        </Stack>
    )
}
